@if (view(); as viewData) {
    <b class="mb-3"> {{ 'common_type-and-model' | translate }} </b>

    @for (vendorModel of viewData.vendorModels; track vendorModel.vendorModelId; let last = $last) {
        <div
            class="d-flex justify-content-between align-items-center mb-2"
            [ngClass]="{'border-bottom': !last}">
            <div class="col-10">
                {{ vendorModel.translatedMeterType }} - {{ vendorModel.modelName }}

                ({{ vendorModel.numberOfMeters }}

                {{ 'properties_meterItemsKey' | translate: 'online' : 'monitoringAlarms' }})

                @if (!vendorModel.isEventTypeSupported) {
                    <span class="badge bg-danger text-white">
                        {{ 'event-alarms_unsupportedEventType' | translate }}
                    </span>
                }
            </div>

            <div class="col-2 text-end p-2">
                <button
                    class="btn btn-sm"
                    [ngClass]="rowButtonClass()"
                    type="button"
                    (click)="removeVendorModel(vendorModel)">
                    <i class="bi" [ngClass]="rowButtonIconClass()"></i>
                </button>
            </div>
        </div>
    }
} @else {
    <app-load />
}
